import { createAsyncThunk } from "@reduxjs/toolkit";
import { IQueryParams, getSearchQuery } from "../../common";
import { axios_api } from "../../api/axios-api";
import { ITablesLayout } from "./tables.types";
import { defaultTablesLayout } from "./tables.state";
import { createAsyncThunkPostWrapper } from "../store.wrapper";

const GET_TABLE_LAYOUTS_BASE_URL = "/layout/get-layout"
const UPSERT_TABLE_LAYOUTS_BASE_URL = "/layout/upsert-layout"

export const fetchAllTablesLayoutAsync = createAsyncThunk<{ recordCount: number, data: ITablesLayout[] }, IQueryParams>(
    'tables/fetchAllTablesLayoutAsync', async (queryParams: IQueryParams, thunkAPI) => {
        const searchQuery = getSearchQuery(queryParams);
        const response = await axios_api.get(`${GET_TABLE_LAYOUTS_BASE_URL}${searchQuery}`)
        const data = response.data.data;
        const count = response.data.totalRecords
        return { recordCount: count, data: data }
    },
)

// export const fetchSingleOutletLayoutsAsync = createAsyncThunk<{ recordCount: number, data: ITablesLayout[] }, string>(
//     'tables/fetchSingleOutletLayoutsAsync', async (uuid, thunkAPI) => {
//         const response = await axios_api.get(`${GET_TABLE_LAYOUTS_BASE_URL}?outlet_uuid=${uuid}&status=ACTIVE`)
export const fetchSingleOutletLayoutsAsync = createAsyncThunk<{ recordCount: number, data: ITablesLayout[] }, {
    outlet_uuid: string,
    exclude_tables?: boolean
    exclude_layout_without_tables?: boolean
}>(
    'tables/fetchSingleOutletLayoutsAsync', async ({ outlet_uuid, exclude_tables, exclude_layout_without_tables }, thunkAPI) => {
        const response = await axios_api.get(`${GET_TABLE_LAYOUTS_BASE_URL}`, {
            params: {
                outlet_uuid,
                ...(exclude_tables && { exclude_tables }),
                ...(exclude_layout_without_tables && { exclude_layout_without_tables }),
                status: "ACTIVE"
            }
        })
        // const response = await axios_api.get(`${GET_TABLE_LAYOUTS_BASE_URL}?outlet_uuid=${uuid}&exclude_tables=true`)
        const data: ITablesLayout[] = response.data.data;
        const count = response.data.totalRecords
        return { recordCount: count, data}
    },
)

export const fetchOutletSingleLayoutAsync = createAsyncThunk<ITablesLayout, string>(
    'tables/fetchOutletSingleLayoutAsync', async (layout_uuid, thunkAPI) => {
        const response = await axios_api.get(`${GET_TABLE_LAYOUTS_BASE_URL}?layout_uuid=${layout_uuid}`)
        const data: ITablesLayout = response.data.data[0];
        console.log("fetchOutletSingleLayoutAsync data==>", data)
        if (data) {
            data.tables = data.tables.filter(table => table?.id)
        }

        console.log("fetchOutletSingleLayoutAsync ==>", data)
        return data ? data : defaultTablesLayout
    },
)

export const upsertSingleTableLayoutAsync = createAsyncThunk<ITablesLayout, ITablesLayout>(
    'tables/upsertSingleTableLayoutAsync', async (payload: ITablesLayout, thunkAPI) => {

        const customizedTablesData = payload.tables.map((table) => {
            return {
                table_id: table.id,
                table_number: table.data.table_number,
                availability: table.data.availability,
                status: table.data.status,
                ...table,
            }
        })
        const response = await axios_api.post(UPSERT_TABLE_LAYOUTS_BASE_URL, { ...payload, tables: customizedTablesData })
        // thunkAPI.dispatch(fetchSingleTableLayoutAsync({
        //     columns: [],
        //     page: 1,
        //     status: "-1",
        //     value: "",
        //     rowsPerPage: 10
        // }))
        return response.data
    },
)


export const createBlankLayoutWithCallbackAsync = createAsyncThunkPostWrapper<ITablesLayout, { payload: ITablesLayout, onCallback: (isSuccess: boolean, data?: ITablesLayout) => void }>(
    'tables/createBlankLayoutWithCallbackAsync', async ({ payload, onCallback }, thunkAPI) => {
        const response = await axios_api.post(UPSERT_TABLE_LAYOUTS_BASE_URL, payload)
        onCallback(true, response.data.data)
        return response.data
    },
)


export const deleteLayoutWithCallbackAsync = createAsyncThunkPostWrapper<ITablesLayout[], { payload: ITablesLayout, onCallback: (isSuccess: boolean, data: string | null) => void }>(
    'tables/deleteLayoutWithCallbackAsync', async ({payload, onCallback}, thunkAPI) => {
        const customizedTablesData = payload.tables.map((table) => {
            return {
                table_id: table.id,
                table_number: table.data.table_number,
                availability: table.data.availability,
                status: "INACTIVE",
                ...table,
            }
        })
        await axios_api.post(UPSERT_TABLE_LAYOUTS_BASE_URL, { ...payload, status: "INACTIVE", tables: customizedTablesData })
        
        const currentLayouts = thunkAPI.getState().tables.layouts_list_without_tables.data
        const finalData = currentLayouts.filter((layout) => layout.layout_uuid !== payload.layout_uuid);

        const activeLayout = finalData.length > 0 ? finalData[0].layout_uuid : null
        onCallback(true, activeLayout)
        return finalData
    },
)


